import PropTypes from "prop-types";

import mana0 from "assets/mana0.svg";
import mana1 from "assets/mana1.svg";
import mana10 from "assets/mana10.svg";
import mana11 from "assets/mana11.svg";
import mana12 from "assets/mana12.svg";
import mana13 from "assets/mana13.svg";
import mana14 from "assets/mana14.svg";
import mana15 from "assets/mana15.svg";
import mana16 from "assets/mana16.svg";
import mana17 from "assets/mana17.svg";
import mana18 from "assets/mana18.svg";
import mana19 from "assets/mana19.svg";
import mana2 from "assets/mana2.svg";
import mana20 from "assets/mana20.svg";
import mana2b from "assets/mana2b.svg";
import mana2g from "assets/mana2g.svg";
import mana2r from "assets/mana2r.svg";
import mana2u from "assets/mana2u.svg";
import mana2w from "assets/mana2w.svg";
import mana3 from "assets/mana3.svg";
import mana4 from "assets/mana4.svg";
import mana5 from "assets/mana5.svg";
import mana6 from "assets/mana6.svg";
import mana7 from "assets/mana7.svg";
import mana8 from "assets/mana8.svg";
import mana9 from "assets/mana9.svg";
import manab from "assets/manab.svg";
import manabg from "assets/manabg.svg";
import manabp from "assets/manabp.svg";
import manabr from "assets/manabr.svg";
import manac from "assets/manac.svg";
import manag from "assets/manag.svg";
import managp from "assets/managp.svg";
import managu from "assets/managu.svg";
import managw from "assets/managw.svg";
import manar from "assets/manar.svg";
import manarg from "assets/manarg.svg";
import manarp from "assets/manarp.svg";
import manarw from "assets/manarw.svg";
import manas from "assets/manas.svg";
import manau from "assets/manau.svg";
import manaub from "assets/manaub.svg";
import manaup from "assets/manaup.svg";
import manaur from "assets/manaur.svg";
import manaw from "assets/manaw.svg";
import manawb from "assets/manawb.svg";
import manawp from "assets/manawp.svg";
import manawu from "assets/manawu.svg";
import manax from "assets/manax.svg";
import multi from "assets/multi.png";

export const map = {
  0: mana0,
  1: mana1,
  10: mana10,
  11: mana11,
  12: mana12,
  13: mana13,
  14: mana14,
  15: mana15,
  16: mana16,
  17: mana17,
  18: mana18,
  19: mana19,
  2: mana2,
  20: mana20,
  "2b": mana2b,
  "2g": mana2g,
  "2r": mana2r,
  "2u": mana2u,
  "2w": mana2w,
  3: mana3,
  4: mana4,
  5: mana5,
  6: mana6,
  7: mana7,
  8: mana8,
  9: mana9,
  b: manab,
  bg: manabg,
  bp: manabp,
  br: manabr,
  c: manac,
  g: manag,
  gp: managp,
  gu: managu,
  gw: managw,
  multi,
  r: manar,
  rg: manarg,
  rp: manarp,
  rw: manarw,
  s: manas,
  u: manau,
  ub: manaub,
  up: manaup,
  ur: manaur,
  w: manaw,
  wb: manawb,
  wp: manawp,
  wu: manawu,
  x: manax,
};

const Mana = ({ color, colors, size }) => {
  const iter = color ? [color.replace("/", "")] : colors.length === 0 ? ["c"] : colors;
  const mySize = size || 20;
  return (
    <>
      {iter.map((colorItem) => (
        <span key={colorItem} style={{ height: mySize, width: mySize }}>
          <img alt={colorItem} height={mySize} width={mySize} src={map[colorItem.toLowerCase()]} />
        </span>
      ))}
    </>
  );
};

Mana.propTypes = {
  color: PropTypes.string,
  colors: PropTypes.arrayOf(PropTypes.string),
  size: PropTypes.number,
};

export default Mana;
